import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import {messagesActions} from 'features/messages';

const useMessages = () => {
  const dispatch = useDispatch();
  const getMessages = useCallback(({ conversation_id, offset, direction, my_id, statuses, senders }) => 
    dispatch(messagesActions.getMessages({ conversation_id, offset, direction, my_id, statuses, senders })), [dispatch]);
  const getMessage = useCallback(({ cable, message_id }) => dispatch(messagesActions.getMessage({ cable, message_id })), [dispatch]);
  const createMessage = useCallback(({ conversation_id, message, local_id }) => dispatch(messagesActions.createMessage({ conversation_id, message, local_id })), [dispatch]);
  const createLocalMessage = (params) => dispatch(messagesActions.createLocalMessage(params));
  const deleteMessage = useCallback(id => dispatch(messagesActions.deleteMessage(id)), [dispatch]);
  const deleteLocalMessage = (id) => dispatch(messagesActions.deleteLocalMessage(id));
  const approveMessage = useCallback(id => dispatch(messagesActions.approveMessage(id)), [dispatch]);
  const rejectMessage = useCallback(id => dispatch(messagesActions.rejectMessage(id)), [dispatch]);
  const setLocalMessageError = useCallback((params) => dispatch(messagesActions.setLocalMessageError(params)), [dispatch]);
  const setLocalMessageFields = useCallback((id) => dispatch(messagesActions.setLocalMessageFields(id)), [dispatch]);
  const clearLocalMessages = useCallback(() => dispatch(messagesActions.clearLocalMessages()), [dispatch]);
  const clearLocalActiveMessage = useCallback(() => dispatch(messagesActions.clearLocalActiveMessage()), [dispatch]);

  return {
    getMessages,
    getMessage,
    createMessage,
    createLocalMessage,
    deleteMessage,
    deleteLocalMessage,
    approveMessage,
    rejectMessage,
    setLocalMessageError,
    setLocalMessageFields,
    clearLocalMessages,
    clearLocalActiveMessage
  };
};

export default useMessages;